import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import Loader from 'features/Loader/Loader';
import { createWorkoutSchema } from 'utils/validators/workout';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import WorkoutCreateForm from './WorkoutCreateForm';
import {
  createWorkout,
  resetUniquenessError
} from '../../ducks/workoutActions';

class WorkoutCreate extends React.Component {
  componentDidMount() {
    this.props.resetUniquenessError();
  }
  render() {
    let { loading, createWorkout, history, uniquenessError } = this.props;
    return (
      <Formik
        initialValues={{
          name: '',
          phase: '',
          level: ''
        }}
        onSubmit={values => {
          return createWorkout(
            { ...values, phase: ~~values.phase },
            history
          );
        }}
        validationSchema={createWorkoutSchema}
      >
        {formik => (
          <Form>
            {formik.isSubmitting || loading ? (
              <Loader />
            ) : (
              <div className="workout workout-create">
                <div className="container">
                  <Breadcrumb>
                    <Breadcrumb.Item href="/workouts">Workouts</Breadcrumb.Item>
                    <Breadcrumb.Item active>Create Workout</Breadcrumb.Item>
                  </Breadcrumb>
                  <div className="page-title">
                    <h4>Create Workout</h4>
                    <div className="title-action">
                      <Link to="/workouts" className="cancel-link">
                        Cancel
                      </Link>
                      <button
                        type="submit"
                        disabled={formik.isSubmitting}
                        className="btn btn-primary"
                      >
                        Create
                      </button>
                    </div>
                  </div>
                  <WorkoutCreateForm
                    isSubmitting={formik.isSubmitting}
                    uniquenessError={uniquenessError}
                  />
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    uniquenessError: state.workoutReducer.uniquenessError,
    loading: state.workoutReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createWorkout: (workout, history) =>
      dispatch(createWorkout(workout, history)),
    resetUniquenessError: () => dispatch(resetUniquenessError())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkoutCreate);
